import { motion } from 'framer-motion';
import { Brain, ShieldCheck, Scales, BookOpen, Handshake, Code } from '@phosphor-icons/react';

const Skills = () => {
  const skills = [
    {
      icon: Brain,
      title: 'Inteligencia Artificial',
      description: 'Experto en aplicación de IA al sector jurídico. Máster en IA. Uso avanzado de ChatGPT, Claude, Gemini y Copilot.',
      index: '01'
    },
    {
      icon: ShieldCheck,
      title: 'Ciberseguridad',
      description: 'Análisis de vulnerabilidades, protección de datos, auditorías de seguridad. Colaborador Unidad Arroba Guardia Civil.',
      index: '02'
    },
    {
      icon: Scales,
      title: 'Derecho Digital',
      description: 'Experto universitario en Derecho Tecnológico y Forense. Ciberdelincuencia, prueba digital, compliance.',
      index: '03'
    },
    {
      icon: BookOpen,
      title: 'Derecho Laboral',
      description: 'Experto en acción de despido. +2000 procedimientos gestionados. Especialista en litigación y defensa laboral.',
      index: '04',
      link: 'https://despido.net'
    },
    {
      icon: Handshake,
      title: 'Negociación',
      description: 'Autor de "La Ciencia del Acuerdo". Formador en técnicas de negociación. Especialista en MASC.',
      index: '05',
      link: 'https://habilidadesabogados.es'
    },
    {
      icon: Code,
      title: 'Legal Tech',
      description: 'Diseñador y desarrollador de plataformas digitales jurídicas. WordPress, e-commerce, SEO aplicado.',
      index: '06'
    }
  ];

  const stats = [
    { value: '+2000', label: 'Casos Gestionados' },
    { value: '30+', label: 'Años Experiencia' },
    { value: '10+', label: 'Plataformas' },
    { value: '3', label: 'Libros' }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.08 }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5 } }
  };

  return (
    <section id="skills" className="py-16 bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {/* Section Header */}
          <motion.div variants={itemVariants} className="mb-12">
            <p className="font-mono text-xs tracking-[0.2em] uppercase text-blue-500 mb-4">
              [03] Áreas de Práctica
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white">
              Expertise Legal & Tecnológico
            </h2>
          </motion.div>

          {/* Skills Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-16">
            {skills.map((skill) => (
              <motion.div
                key={skill.index}
                variants={itemVariants}
                className="group p-6 bg-[#0F0F0F] border border-white/10 card-hover"
                data-testid={`skill-${skill.title.toLowerCase().replace(/\s/g, '-')}`}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 flex items-center justify-center border border-blue-500/30 bg-blue-500/10 group-hover:bg-blue-500/20 transition-colors">
                    <skill.icon size={24} className="text-blue-500" weight="light" />
                  </div>
                  <span className="font-mono text-xs text-white/30">[{skill.index}]</span>
                </div>
                
                <h3 className="text-lg font-medium text-white mb-2">
                  {skill.title}
                </h3>
                
                <p className="text-sm text-white/50 leading-relaxed mb-3">
                  {skill.description}
                </p>
                
                {skill.link && (
                  <a
                    href={skill.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-mono text-xs text-blue-500 hover:text-blue-400 transition-colors uppercase tracking-wider"
                  >
                    Ver más →
                  </a>
                )}
              </motion.div>
            ))}
          </div>

          {/* Stats */}
          <motion.div 
            variants={itemVariants}
            className="grid grid-cols-2 md:grid-cols-4 gap-4"
          >
            {stats.map((stat, index) => (
              <div
                key={index}
                className="p-6 bg-[#0F0F0F] border border-white/10 text-center"
                data-testid={`stat-${stat.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                <p className="text-3xl sm:text-4xl font-medium text-blue-500 mb-2">
                  {stat.value}
                </p>
                <p className="font-mono text-xs text-white/50 uppercase tracking-wider">
                  {stat.label}
                </p>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
